import { ca } from '@cian/analytics';

import { getNewbuildingProduct } from '../../utils/analytics';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

export function trackPromoOffersShow(promos: IPromoInfo[], newbuildingId: number, isMortgage = false) {
  const promoId = promos.map(({ promoId, promoType }, index) => ({
    promo_type: promoType,
    promo_id: promoId,
    position: index + 1,
  }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: isMortgage ? 'mortgage_offers' : 'promo_offers',
    name: 'oldevent',
    products: [getNewbuildingProduct({ newbuildingId, extra: { promoId } })],
  });
}
